export function get_api_path() {
    //dev
//    return("http://o.mfaconsultancyllc.com:3300/");
    //staging
//    return("http://o.mfaconsultancyllc.com:8080/api3/");
    //production
    return("https://office.mfaconsultancyllc.com/api3/");
}
